class StickyAddToCart {
  constructor() {
    this.stickyAddToCart = document.querySelector('.stickyAddToCart');
    this.mainAddToCart = document.querySelector('.mainProductForm .addToCart');
    
    if (!this.stickyAddToCart || !this.mainAddToCart) return;
    
    this.setupIntersectionObserver();
  }
  
  setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          // Show sticky add to cart when main button is NOT intersecting (not in viewport)
          if (!entry.isIntersecting) {
            this.stickyAddToCart.style.transform = 'translateY(0)';
          } else {
            this.stickyAddToCart.style.transform = 'translateY(100%)';
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }
    );
    
    observer.observe(this.mainAddToCart);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new StickyAddToCart();
}); 